import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import useParentRoute from 'hooks/useParentRoute';
import posthog from 'posthog-js';
import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { FormInput, FormPanel } from 'components/FormPanel';

import Alert from 'primitives/Alert';

import { getUser } from 'utils/auth';

const SUBMIT_USER_FOR_REVIEW_MUTATION = gql(`
  mutation SubmitUserForReview($id: ID!, $investmentEntityId: ID!) {
    submitUserForReview(id: $id, investmentEntityId: $investmentEntityId) {
      id
      status
    }
  }
`);

const SubmitUserForReview: FC = () => {
  const navigate = useNavigate();
  const parentRoute = useParentRoute();
  const { investmentEntityId } = useParams<{ investmentEntityId: string }>() as {
    investmentEntityId: string;
  };

  const { id } = getUser();

  const [submitForReview, { loading, error }] = useMutation(SUBMIT_USER_FOR_REVIEW_MUTATION);

  return (
    <FormPanel
      loading={loading}
      error={error}
      onSubmit={data => {
        submitForReview({
          variables: {
            id,
            investmentEntityId,
          },
        }).then(() => {
          posthog.capture('onboarding_completed', {
            user_type: 'investor',
          });
          navigate(`/under-review-user`);
        });
      }}
      onCancel={() => {
        navigate(`${parentRoute}/investor-application`);
      }}
      submitButtonLabel="Submit"
      cancelButtonLabel="Back"
    >
      <FormInput
        type="switch"
        fieldName="disclaimer"
        label="I confirm that the information provided is accurate to the best of my knowledge"
        defaultValue=""
        validators={{
          required: true,
        }}
      />
      <Alert
        type="info"
        title=""
        message="Please note that SEBI has mandated all AIFs to issue units in dematerialised form only. Accordingly, the investor must hold an active demat account at the time of making investments. Furthermore, the bank account and the demat account must be registered in the same name as that of the investor (i.e., the investing entity)."
      />
    </FormPanel>
  );
};

export default SubmitUserForReview;
